import { render, staticRenderFns } from "./sewage.vue?vue&type=template&id=1b2385d1&scoped=true&"
import script from "./sewage.vue?vue&type=script&lang=js&"
export * from "./sewage.vue?vue&type=script&lang=js&"
import style0 from "./sewage.vue?vue&type=style&index=0&id=1b2385d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2385d1",
  null
  
)

export default component.exports